import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss']
})
export class ContentComponent implements OnInit {

  user
  applicableHomepage

  constructor(private route: Router) { }

  ngOnInit() {
    
  }

  get redirectToHomepage(){
    let baseRef = environment.server;
    if (!baseRef.endsWith("/")) {
      baseRef += "/";
    }

    let path = '/dashboard/page/vessel';
    let external = "web/#";

    if (this.applicableHomepage && this.applicableHomepage!='/home'){

      path = this.applicableHomepage;

      if (!path.startsWith("/")) {
        path += "/";
      }

    }

    return baseRef + external + path;

  }

}
